<script setup lang="ts">
import type { RadioProps } from '@formwerk/core'
import { useRadio } from '@formwerk/core'

const props = defineProps<RadioProps<string>>()

const { inputProps, labelProps, isChecked } = useRadio(props)
</script>

<template>
  <label
    v-bind="labelProps"
    class="typo-sans-1 leading-none cursor-pointer select-none uppercase has-[:disabled]:opacity-50 has-[:disabled]:cursor-not-allowed"
  >
    <input v-bind="inputProps" class="peer sr-only">
    <span
      class="px-2 py-1.5 motion-snug rounded block @hover:c-lilac peer-focus-visible:outline-2 peer-focus-visible:outline-current peer-focus-visible:outline-offset-2 peer-focus-visible:outline @hover:bg-wine"
      :class="isChecked ? 'bg-wine c-lilac' : 'bg-lilac'"
    >
      {{ label }}
    </span>
  </label>
</template>
